import React, { type PropsWithChildren } from 'react';

import { HStack, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemNutrition = (props: PropsWithChildren) => {
  const { children } = props;

  return <HStack gap={theme.spacing['4']}>{children}</HStack>;
};
